import { roles } from '@constants/index';
import NotFound from '@pages/not-found';
import Profile from '@pages/profile';
import Reports from '@pages/reports';
import { Route } from '@utils/types';
import React from 'react';

const LandingPage = React.lazy(() => import('@pages/home'));
const Login = React.lazy(() => import('@pages/login'));
const Dashboard = React.lazy(() => import('@pages/dashboard'));
const Lead = React.lazy(() => import('@pages/leads'));
const BenefitsPage = React.lazy(() => import('@pages/benefits'));

export const routes: Route[] = [
  {
    path: '/',
    key: 'landingPage',
    element: <LandingPage />,
    isProtected: false,
  },
  {
    path: '/login',
    key: 'login',
    element: <Login />,
    isProtected: false,
  },
  {
    path: '/dashboard',
    key: 'dashboard',
    element: <Dashboard />,
    showInNav: true,
    title: 'Summary',
    isProtected: true,
  },
  {
    path: '/reports',
    key: 'reports',
    showInNav: true,
    title: 'Reports',
    element: <Reports />,
    isProtected: true,
  },
  {
    path: '/benefits',
    key: 'benefits',
    element: <BenefitsPage />,
    showInNav: true,
    title: 'Benefits',
    excludedRoles: [roles.nonVPP],
    isProtected: true,
  },
  {
    path: '/lead',
    key: 'lead',
    element: <Lead />,
    showInNav: true,
    title: 'Leads',
    isProtected: true,
  },
  {
    path: '/profile',
    key: 'profile',
    element: <Profile />,
    isProtected: true,
  },
  {
    path: '*',
    key: 'not-found',
    element: <NotFound />,
    isProtected: false,
  },
];
